<template>
  <span v-html="footer"/>
</template>

<script>
import axios from 'axios'
import xcHelperMixin from '../mixins/xc-helper'
import { i18n } from '../plugins/vue-i18n'

export default {
  name: 'Footer',
  mixins: [xcHelperMixin],
  data () {
    return {
      footer: null
    }
  },
  created: async function () {
    await this.getFooter()

    this.newsletterListener()
  },
  methods: {
    getFooter: async function () {
      await axios.get(`/footer/${i18n.locale}`)
        .then((response) => {
          this.footer = response.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue